import React from 'react';
import PropTypes from 'prop-types';

import { Field, reduxForm } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';

import Section, { SectionHeader, SectionTitle } from 'components/common/Section';
import Button from 'components/common/Button';
import CheckboxField from 'components/fields/CheckboxField';

const styles = theme => ({
  section: {
    position: 'fixed',
    top: 64,
    zIndex: 100,
    left: 272,
    right: 8,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    padding: '26px 8px 0 8px',
    boxShadow: 'none',
    overflow: 'hidden',
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: -40,
      left: -8,
      right: -8,
      bottom: 0,
      marginTop: 1,
      zIndex: -10,
      backgroundColor: theme.palette.grey[100],
    },
  },
  sectionHeader: {
    backgroundColor: theme.palette.common.white,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    boxShadow: '0 2px 10px 0 rgba(72,126,161,0.14)',
    borderBottom: `1px solid ${theme.palette.primary.A400}`,
  },
  sectionBody: {
    padding: '60px 80px',
  },
  article: {
    border: `1px solid ${theme.palette.primary.A400}`,
    padding: 24,
    marginTop: 24,
  },
  table: {
    marginTop: 24,
  },
  tableRow: {
    height: 42,
  },
  tableCell: {
    borderLeft: `1px solid ${theme.palette.primary.A400}`,
    borderRight: `1px solid ${theme.palette.primary.A400}`,
    borderTop: `1px solid ${theme.palette.primary.A400}`,
  },
  button: {
    marginLeft: 20,
  },
  error: {
    marginBottom: 24,
  },
});

const PaymentContractHeader = ({ history, onSignButtonClick, classes, pristine, disabled }) => (
  <Section className={classes.section}>
    <SectionHeader className={classes.sectionHeader}>
      <SectionTitle>
        Step 3: Sign Contract
      </SectionTitle>
      <div>
        <Field
          id="I agree with terms and conditions"
          name="I agree with terms and conditions"
          label="I agree with terms and conditions"
          component={CheckboxField}
          disabled={disabled}
        />
        <Button
          className={classes.button}
          variant="raised"
          onClick={() => {
            history.goBack();
          }}
        >
          Back
        </Button>
        <Button
          className={classes.button}
          onClick={() => {
            onSignButtonClick();
          }}
          variant="raised"
          color="primary"
          disabled={pristine || disabled}
        >
          Sign
        </Button>
      </div>
    </SectionHeader>
  </Section>
);

PaymentContractHeader.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  pristine: PropTypes.bool.isRequired,
  onSignButtonClick: PropTypes.func,
  classes: PropTypes.shape({
    sectionBody: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
  }).isRequired,
};

PaymentContractHeader.defaultProps = {
  error: null,
  onSignButtonClick: () => {},
};

export default reduxForm({
  form: 'paymentContract',
  initialValues: {
    'I agree with terms and conditions': false,
  },
})(withStyles(styles)(PaymentContractHeader));



// WEBPACK FOOTER //
// ./src/components/settings/PaymentContractHeader/PaymentContractHeader.js